export const ACCORDION_COLLAPSE_MS = 280;

/**
 * Azul da linha de categoria.
 *
 * Consumido pelo cabeçalho da categoria na visão "Por Fornecedor" e pela linha
 * da visão "Por Agrupamento" — é a mesma linha, recortada de outro jeito, e
 * duas cores dariam a impressão de duas coisas diferentes.
 */
export const CATEGORY_ROW_BACKGROUND = "#3B668B";

export const categoryAccordionTransitionProps = {
  unmountOnExit: true,
  timeout: { enter: ACCORDION_COLLAPSE_MS, exit: ACCORDION_COLLAPSE_MS },
  easing: {
    enter: "cubic-bezier(0.4, 0, 0.2, 1)",
    exit: "cubic-bezier(0.4, 0, 0.2, 1)",
  },
};

export const categoryAccordionSx = {
  my: 2,
  borderRadius: "4px",
  border: "none",
  overflow: "hidden",
  "&:before": { display: "none" },
  "& .MuiAccordionSummary-root": {
    transition: "min-height 200ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transition: "transform 280ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  "& .MuiCollapse-root": {
    transition: `height ${ACCORDION_COLLAPSE_MS}ms cubic-bezier(0.4, 0, 0.2, 1) !important`,
  },
};
